import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Loader from './../shared/loader'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


import {
  Validator
} from 'vee-validate'


export default {
  name: 'config',
  components: {
    Loader
  },
  props: [],
  data() {
    return {
      mrpchecknew: '',
      expirycheck: '',
      recordToDelete: '',
      removecompName: '',
      removeData: false,
      EcommList: [],
      CourierCompList: '',
      Cname: '',
      Otype: '',
      OtypeErr: '',
      ecomm: '',
      ecommError: false,
      isLoading: false,
      pickingtype: '',
      pickingsize: '',
      flag: '',
      defaultsize: '',
      tabIndex: 0,
      config: [],
      showBatch: true,
      showpickingsizeerror: '',
      showdefaultsizeerror: '',
      showpicksizeerror: '',
      showpickingtypeerror: '',
      showflagerror: '',
      localwarehouseid: '',
      pickingData: [],
      RoleListData: [],
      types: ["cluster", "batch"],
      assigntype: '',
      showassigntypeerror: '',
      rtoInscan: '',
      rtoInscanError: false,
      showSelectClient: false,
      showSelectWarehouse: false,
      clientListData: [],
      listWarehouseData: [],
      client: '',
      warehouse: '',
      ClientErr: '',
      WarehouseErr: '',
      roleid: '',
      searchFlag: true,
      sessiontime: '',
      audit: false,
      Tolerancepercentage: '',
      roleiderror: '',
      expcount: '',
      localclientid: 0,
      mrpExpFlag: false,
      expiryDayError: '',
      mrpAndExpiryFlag: false,
      outboundDisble: false,
      pickerDisable: false,
      rtoDisable: false,
      auditDisable: false,
      grcDisable: false,
      ecomDisable: false,
      mrpDisable: false,

      enableInvoice: false,
      selectedImageFile: '',
      custAcknowled: '',
      custAcknowledError: '',
      returnPolicy: '',
      returnPolicyError: '',
      tandc: '',
      tandcError: '',
      officeAddress: '',
      officeAddressError: '',
      ccphone: '',
      ccphoneError: '',
      ccemail: '',
      ccemailError: '',
      imageObject: [],
      logoname: '',
      editor: ClassicEditor,
      editorConfig: {},
      ecommxb: '',
      ecommErrorxb: false,
      partialorder: '',
      enableLabel: false,
      autoMatchError: '',
      autoMatch: '',
      maxval: '',
      autocreate: '',
      showautocreateerror: '',
      maximumvalue: '',
      showmaximumvalueerror: '',
      marketplace: '',
      marketplaceError: false,
      orderprocessing: '',
      orderprocessingError: false,
      reservestock: '',
      reservestockError: false,
      rackprefix: '',
      rackprefixError: false,
      rackError: '',
      manifestlimit: '',
      manifestError: false,
      smartrack: '',
      smartrackError: false,
      audittime: '',
      errorAuditHour: false,
      rackprefixtemp: '',
      multimerchant: '',
      multimerchantError: false,
      hasPrefix: false,
      excessqty: '',
      excessqtyError: '',
      excessprodqty: '',
      excessprodqtyError: '',
      enabledrcheck: '',
      enabledrcheckerror: '',
      pickqtysize: '',
      showpickqtysizeerror: '',
      pickflag: '',
      b2bqty: '',
      b2bqtyError: '',
      enablemultirackcheck: '',
      enablemultirackcheckerror: '',
      showpickflagerror: '',
      expiryThreshold: '',
      expiryThresholdError: false,
      returnThresholdDays: '',
      enablesubinvcheck: '',
      enablesubinvcheckerror: '',
      packingbox: '',
      showpackingboxerror: '',
      fcwarehouseError:'',
      fcwarehouse : '',
      uploadinvoice:'',
      uploadinvoiceError:false,
      routingenabled : '',
      routingEnabledError: '',
      returnsIntegration : '',
      returnsIntegrationError : false,
      splitbox : '',
      splitboxerror :'',
      activemrp : 'no',
      showDefault:true,
      enablecrossdock:'',
      disablecrossdock:'',
      crossdock:'',
      crossdockerror:'',
      searchQuery: null,
      listProductCategory:[],
      channellist:[],
      search1:null,
      productcategory : [],
      salesChannel:[],
      searchsaleschannel:'',
      searchchannel:'',
      specialInstructionButtonType:'add',
      specialInstructionList:[],
      specialInstructionCount:0,
      createdbyEmail:'',
      instructionNameEditTextarea:'',
      instructionNameAddTextarea:'',
      isEditing:false,
      editingSalesChannel:'',
      editingInstructionId:'',
      specialInstructionValidation:false,
      salesChannelValidation:false,
      closeSpecialInstructionModal:false,
      deleteSalesChannel:'',
      deleteInstructionId:'',
      deleteInstructionName:'',
      searchprodcat:'',
      scount:0,
      pcount : 0,
      selectedproductcat:[],
      selectedsaleschannel:[],
      disableSelection: false,
      showEancodeError : '',
      eancodeFlag : 0,
      showAutofillboxError:'',
      autofillboxFlag:0,
      enableautodrclose:0,
      enableautodrcloseerror:'',
      enablespoc:0,
      enablespocerror:''
    }
  },
  computed: {
    resultsalesChannel(){
      if(this.searchsaleschannel){
       return this.salesChannel.filter((item)=>{
         return this.searchsaleschannel.toLowerCase().split(' ').every(v => item.saleschannel.toLowerCase().includes(v))
       })
     }else{
       return this.salesChannel;
     }
   },
   resultproductCategory(){
      if(this.searchprodcat){
       return this.productcategory.filter((item)=>{
         return this.searchprodcat.toLowerCase().split(' ').every(v => item.productcategory.toLowerCase().includes(v))
       })
     }else{
       return this.productcategory;
     }
   },
  },
  mounted() {
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    // this.getRoleList();
    //this.getconfig();
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    if (localStorage.getItem("selectedClient")!=='undefined')
    {
      // this.getconfig();
      // this.getconfigForEcomm()
      this.getSpecialInstruction()
      if (localStorage.getItem("selectedWarehouse")) {
              if (this.user_type != 'system_user') {
                this.searchFlag = true;
              } else {
                this.searchFlag = false;
              }
            }
            setTimeout(() => {
                this.changeEnableCrossdock()
              }, 500);

    }
    if (localStorage.getItem("selectedWarehouse")!=='undefined')
		{
      if (localStorage.getItem("selectedClient")) {
              // this.getconfig();
              this.searchFlag = true;
      }
      // this.getconfig()
      this.getconfigForEcomm()
      this.getCourierCompList()
      this.getSalesChannels()
      this.getRoleList()
      this.getProductCategory()
    }
    this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data

      if (newValue !== undefined ){
			this.warehouse = newValue;
			this.getconfig();
      this.getSalesChannels();
      }
		  });
    this.user_type = userdetail.utype;
    this.createdbyEmail = userdetail.email;
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        this.loginuserid = userdetail.userid;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.localclientid = userdetail.clientid;
        this.loginuserid = userdetail.userid;
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginuserid = userdetail.userid;
        this.localwarehouseid = userdetail.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }



    // this.getCourierCompList();
    this.getconfig();

  },
  methods: {

    selectChannel(item, key) {
      const targetItem = this.resultsalesChannel[key];
      if (!targetItem) return;
        if (targetItem.isselected) {
          targetItem.isselected = false;
          this.scount--;
          this.selectedsaleschannel = this.selectedsaleschannel.filter(channel => channel !== targetItem.saleschannel);
        } else {
        targetItem.isselected = true;
          if(!this.selectedsaleschannel.includes(targetItem.saleschannel)) {
            this.selectedsaleschannel.push(targetItem.saleschannel);
            this.scount++;
          }
        }
    },
    selectCategory(item, key) {
      const targetItem1 = this.resultproductCategory[key];
      if (!targetItem1) return;
      if (targetItem1.isselected) {
        targetItem1.isselected = false;
        this.selectedproductcat = this.selectedproductcat.filter(cat => cat !== targetItem1.productcategory);
        this.pcount--;
      } else {
      targetItem1.isselected = true;
        if(!this.selectedproductcat.includes(targetItem1.productcategory)) {
          this.selectedproductcat.push(targetItem1.productcategory);
          this.pcount++;
        }
      }
    },
      selectAllChannel() {
        this.resultsalesChannel.forEach(item => {
        item.isselected = true;
          if(!this.selectedsaleschannel.includes(item.saleschannel)) {
            this.selectedsaleschannel.push(item.saleschannel);
          }
        });
       this.scount = this.resultsalesChannel.length;
      },

      selectAllProductCat() {
        this.resultproductCategory.forEach(item => {
          item.isselected = true;
          if(!this.selectedproductcat.includes(item.productcategory)) {
            this.selectedproductcat.push(item.productcategory);
          }
        });
       this.pcount = this.resultproductCategory.length;
      },
  //  selectCategory(item,key){
  //   for (let i = 0; i < this.resultproductCategory.length; i++) {
  //       if (this.resultproductCategory.indexOf(item) === key) {
  //        if(item.isselected === true){
  //           item.isselected = false
  //           this.selectedproductcat.pop(item.productcategory);
  //           console.log(this.selectedproductcat);
  //           this.pcount -= 1;
  //           break;
  //         }else{
  //           item.isselected = true
  //           this.selectedproductcat.push(item.productcategory);
  //           this.pcount += 1;
  //          break;
  //         }
  //       }
  //     }
  //  },

    onUploadImage() {

      this.getconfig();
      let formData = new FormData();
      this.selectedImageFile = event.target.files[0];
      formData.append('files', this.selectedImageFile);

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'fileUpload',
        'data': formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(result => {
          if (result.data.erroCode == 0) {
            //this.$alertify.success(result.data.msg);
            this.imageObject = result.data.data;
            //this.saveTicketMedia();
            //console.log(this.imageObject[0]);
            //this.$router.push('/ViewTickets')
          } else {
            this.logoname = result.data.filename;
          }

        })
    },
    validateEmail() {
      var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (this.ccemail.trim() != "") {
        if (!filter.test(this.ccemail)) {
          this.ccemailError =  this.$t('config.ccEmailerror');
          return false;
        } else {
          this.ccemailError = "";
          return true;
        }
      }
    },
    saveInvoiceData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (this.ccemail.trim() != "") {
        if (!filter.test(this.ccemail)) {
          this.ccemailError = this.$t('config.ccEmailerror');
          return false;
        }
      }


      this.input = ({
        config: [{
          "clientid": localStorage.getItem("selectedClient"),
          "flag": this.enableInvoice == true ? 'yes' : 'no',
          "type": 'print_invoice_ONOFF'
        },
        {
          "clientid": localStorage.getItem("selectedClient"),
          "flag": this.enableLabel == true ? 'yes' : 'no',
          "type": 'print_label_ONOFF'
        },
        {
          "clientid": localStorage.getItem("selectedClient"),
          "value": this.logoname,
          "flag": 'yes',
          "type": 'client_logo'
        },
        {
          "clientid": localStorage.getItem("selectedClient"),
          "value": this.custAcknowled,
          "flag": 'yes',
          "type": 'customer_acknowledgement'
        },
        {
          "clientid": localStorage.getItem("selectedClient"),
          "value": this.returnPolicy,
          "flag": 'yes',
          "type": 'return_policy'
        },
        {
          "clientid": localStorage.getItem("selectedClient"),
          "value": this.tandc,
          "flag": 'yes',
          "type": 'terms_and_conditions'
        },
        {
          "clientid": localStorage.getItem("selectedClient"),
          "value": this.officeAddress,
          "flag": 'yes',
          "type": 'office_address'
        },
        {
          "clientid": localStorage.getItem("selectedClient"),
          "value": this.ccphone,
          "flag": 'yes',
          "type": 'customer_care_phone'
        },
        {
          "clientid": localStorage.getItem("selectedClient"),
          "value": this.ccemail.trim(),
          "flag": 'yes',
          "type": 'customer_care_email'
        },
        {
          "clientid": localStorage.getItem("selectedClient"),
          "value": this.uploadinvoice,
          "flag": 'yes',
          "type": 'upload_invoice_dr'
        },
        ],
        module: 'customer_invoice',
        //warehouseidlocal: this.localwarehouseid,
        localclientid: parseInt(this.localclientid),
      });

      this.isLoading = true;
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data.code == 0) {
            this.ccemailError = '';
            document.getElementById('ccphone').value = "";
            document.getElementById('ccemail').value = "";
            this.isLoading = false;
            this.$alertify.success(response.data.data.msg);
            this.getconfig();
          } else if (response.data.data.code == -1) {
            this.isLoading = false;
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    lotMrpControl() {
      this.mrpExpFlag = false;
      this.mrpAndExpiryFlag = false;
      if (this.expirycheck == "" && this.mrpchecknew == "" && this.partialorder == "") {
        return false;
      } else if (this.expirycheck != "" && this.mrpchecknew == "") {
        if (this.expirycheck == "yes" && (parseInt(this.expcount) <= 0 || this.expcount == "")) {
          this.expiryDayError = this.$t('config.daysMorethanZero');
          return false;
        } else {
          this.expiryDayError = "";
        }
        this.saveExpiry();
      } else if (this.expirycheck == "" && this.mrpchecknew != "" && this.partialorder == "") {
        this.saveMrp();
      } else if (this.expirycheck == "" && this.mrpchecknew == "" && this.partialorder != "") {

        this.savePartialOrder();
      } else {
        if (this.expirycheck == "yes" && (parseInt(this.expcount) <= 0 || this.expcount == "")) {
          this.expiryDayError = this.$t('config.daysMorethanZero');
          return false;
        } else {
          this.expiryDayError = "";
        }
        this.mrpExpFlag = true;
        this.mrpAndExpiryFlag = true;
        this.saveExpiry();
        this.savePartialOrder();

      }
      //  if(this.b2bqty !== ''){
      this.saveThresholdQty();
      this.savePackingBox();
      //}
      this.saveActiveMrp()
    },
    savePackingBox() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      if (localStorage.getItem("selectedClient")== "") {
        return false
      } else {
        this.input = ({
          config: [{
            "clientid": localStorage.getItem("selectedClient"),
            "value": this.packingbox,
            "type": 'packingbox'
          }],
          module: 'packingbox',
          localclientid: parseInt(localStorage.getItem("selectedClient")),
        });
      }

      this.isLoading = true
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          this.isLoading = false;
          if (response.data.data.code == 0) {
            this.getconfig();
          } else if (response.data.data.code == -1) {
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    saveSplitBox() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      if (localStorage.getItem("selectedClient") == "") {
        return false
      }
      else if(this.splitbox == "" || this.splitbox === null)
      {
         this.splitboxerror = 'Please Select An Option';
         return false;
      }
      else {
        this.input = ({
          config: [{
            "clientid": localStorage.getItem("selectedClient"),
            "value": this.splitbox,
            "type": 'split_box'
          }],
          module: 'split_box',
          localclientid: parseInt(localStorage.getItem("selectedClient")),
        });
      }

      this.isLoading = true
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          this.isLoading = false;
          if (response.data.data.code == 0) {
            this.$alertify.success(response.data.data.msg);
            //this.getconfig();
          } else if (response.data.data.code == -1) {
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    saveThresholdQty() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (this.b2bqty <= 1 && this.b2bqty != '') {
        this.b2bqtyError = this.$t('config.thresholdLessthanOne');
      } else {
        this.b2bqtyError = '';
        if (localStorage.getItem("selectedClient") == "") {
          this.input = ({
            config: [{
              "warehouseid": localStorage.getItem("selectedWarehouse"),
              "value": this.b2bqty,
              "type": 'threshold_order_qty'

            }],
            module: 'threshold_order_qty',
            warehouseidlocal: this.localwarehouseid,
          });

        } else {
          this.input = ({
            config: [{
              "clientid": localStorage.getItem("selectedClient"),
              "value": this.b2bqty,
              "type": 'threshold_order_qty'
            }],
            module: 'threshold_order_qty',
            localclientid: parseInt(localStorage.getItem("selectedClient")),
          });
        }

        this.isLoading = true
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            this.b2bqty = '';

            if (response.data.data.code == 0) {
              this.isLoading = false;
              this.getconfig();

            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })

      }

    },
    saveExpiry() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var flagexp = this.expirycheck;
      if (localStorage.getItem("selectedClient") == "") {
        this.input = ({
          config: [{
            "warehouseid": localStorage.getItem("selectedWarehouse"),
            "value": this.expcount,
            "flag": flagexp,
            "defaultval": "days",
            "type": 'order_exp_check'
          }],
          module: 'order_exp_check',
          warehouseidlocal: localStorage.getItem("selectedClient"),
        });

      } else {
        this.input = ({
          config: [{
            //"warehouseid": this.localwarehouseid,
            "clientid": localStorage.getItem("selectedClient"),
            "value": this.expcount,
            "flag": flagexp,
            "defaultval": "days",
            "type": 'order_exp_check'
          }],
          module: 'order_exp_check',
          //warehouseidlocal: this.localwarehouseid,
          localclientid: parseInt(localStorage.getItem("selectedClient")),
        });
      }
      this.isLoading = true
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data.code == 0) {
            this.expcount = '';
            this.expirycheck = '';
            //document.getElementById('expcount').value = '';
            if (this.mrpAndExpiryFlag == false) {
              this.getconfig();
            } else {
              this.saveMrp();
            }

            this.isLoading = false;
            this.$alertify.success(response.data.data.msg);
          } else if (response.data.data.code == -1) {
            this.isLoading = false
            if (this.mrpExpFlag == false) {
              this.$alertify.error(response.data.data.msg)
            }

          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    saveMrp() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var flagmrp = this.mrpchecknew;

      if (localStorage.getItem("selectedClient") == "") {
        this.input = ({
          config: [{
            "warehouseid": this.localStorage.getItem("selectedWarehouse"),
            "flag": flagmrp,
            "type": 'order_mrp_check'
          }],
          module: 'order_mrp_check',
          warehouseidlocal: localStorage.getItem("selectedWarehouse"),
        });

      } else {
        this.input = ({
          config: [{
            //"warehouseid": this.localwarehouseid,
            "clientid": localStorage.getItem("selectedClient"),
            "flag": flagmrp,
            "type": 'order_mrp_check'
          }],
          module: 'order_mrp_check',
          //warehouseidlocal: this.localwarehouseid,
          localclientid: parseInt(localStorage.getItem("selectedClient")),
        });
      }


      this.isLoading = true
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data.code == 0) {
            //this.getconfig();
            this.isLoading = false;
            if (this.mrpExpFlag == false) {
              this.$alertify.success(response.data.data.msg);
            }

          } else if (response.data.data.code == -1) {
            this.isLoading = false
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    savePartialOrder() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var flagmrp = this.partialorder;

      this.input = ({
        config: [{
          "clientid": localStorage.getItem("selectedClient"),
          "flag": flagmrp,
          "type": 'partial_order'
        }],
        module: 'partial_order',
        localclientid: parseInt(localStorage.getItem("selectedClient")),
      });
      this.isLoading = true
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data.code == 0) {

            this.isLoading = false;
            if (this.mrpExpFlag == false) {
              this.getconfig();
              this.$alertify.success(response.data.data.msg);
            }

          } else if (response.data.data.code == -1) {
            this.isLoading = false
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    saveActiveMrp() {
     var userToken = window.localStorage.getItem('userToken')
     var myStr = userToken.replace(/"/g, '');

     if (localStorage.getItem("selectedClient") == "") {
       return false
     } else {
       this.input = ({
         config: [{
           "clientid": localStorage.getItem("selectedClient"),
           "value": this.activemrp,
           "type": 'activemrp'
         }],
         module: 'activemrp',
         localclientid: parseInt(localStorage.getItem("selectedClient")),
       });
     }

     this.isLoading = true
     axios({
       method: 'POST',
       'url': apiUrl.api_url + 'saveconfig',
       'data': this.input,
       headers: {
         'Authorization': 'Bearer ' + myStr
       }
     })
       .then((response) => {
         this.isLoading = false;
         if (response.data.data.code == 0) {
           this.getconfig();
         } else if (response.data.data.code == -1) {
           this.$alertify.error(response.data.data.msg)
         }
       })
       .catch((httpException) => {
         console.error('exception is:::::::::', httpException)
       })
   },
   changeEnableCrossdock(){
    console.log("==========="+this.crossDock+"=============")
    if(this.crossdock){
      if(this.crossdock == 'no'){
        document.getElementById('prodcat').disabled = true;
        document.getElementById('channel').disabled = true;
        this.disableSelection = true;
        this.selectedproductcat.splice(0, this.selectedproductcat.length);
        this.selectedsaleschannel.splice(0, this.selectedsaleschannel.length);
       }else if(this.crossdock == 'yes'){
        document.getElementById('prodcat').disabled = false;
        document.getElementById('channel').disabled = false;
        this.disableSelection = false;
       }
    }

   },
    crossDock() {
      var userToken = window.localStorage.getItem('userToken')
       var myStr = userToken.replace(/"/g, '');
       if(this.crossdock == 'yes'){
        if(!this.selectedproductcat || this.pcount == 0 ){
          this.$alertify.error(this.$t('crossDock.catgoryMsg'))
          return false;
        }
       }
       if (localStorage.getItem("selectedClient") == "undefined") {
           if(localStorage.getItem("selectedWarehouse")!='undefined' ){
            this.input = ({
              config: [{
                "type":"enableCrossdock",
                "value": this.crossdock ,
                "warehouseid":localStorage.getItem("selectedWarehouse")
               },
              {
                "type":"crosdoc_categories",
                "value":JSON.stringify(this.selectedproductcat),
                "warehouseid":localStorage.getItem("selectedWarehouse")
                },
                {
                  "type":"crosdoc_saleschannel",
                  "value":JSON.stringify(this.selectedsaleschannel),
                  "warehouseid":localStorage.getItem("selectedWarehouse")
                }
            ],
              module: 'crossdock',
              warehouseidlocal: localStorage.getItem("selectedWarehouse"),
            });
           }else{
            this.input = ({
              config: [{
                "type":"enableCrossdock",
                "value": this.crossdock
               },
              {
                "type":"crosdoc_categories",
                "value":JSON.stringify(this.selectedproductcat)
                },
                {
                  "type":"crosdoc_saleschannel",
                  "value":JSON.stringify(this.selectedsaleschannel),
                }
            ],
              module: 'crossdock',
              warehouseidlocal: localStorage.getItem("selectedWarehouse"),
            });
           }
      } else {
        if(localStorage.getItem("selectedWarehouse")!='undefined' ){
            this.input = ({
              config: [{
                "clientid": localStorage.getItem("selectedClient"),
                "type":"enableCrossdock",
                "value": this.crossdock,
                "warehouseid":localStorage.getItem("selectedWarehouse")
                },
                {
                  "clientid": localStorage.getItem("selectedClient"),
                  "type":"crosdoc_categories",
                  "value":JSON.stringify(this.selectedproductcat),
                  "warehouseid":localStorage.getItem("selectedWarehouse")
                  },
                  {
                    "clientid": localStorage.getItem("selectedClient"),
                    "type":"crosdoc_saleschannel",
                    "value":JSON.stringify(this.selectedsaleschannel),
                    "warehouseid":localStorage.getItem("selectedWarehouse")
                    }
              ],
                module: 'crossdock',
                localclientid: parseInt(localStorage.getItem("selectedClient")),
                warehouseidlocal: localStorage.getItem("selectedWarehouse"),
              });
          }else{
            this.input = ({
              config: [{
                "clientid": localStorage.getItem("selectedClient"),
                "type":"enableCrossdock",
                "value": this.crossdock,
                },
                {
                  "clientid": localStorage.getItem("selectedClient"),
                  "type":"crosdoc_categories",
                  "value":JSON.stringify(this.selectedproductcat),
                  },
                  {
                    "clientid": localStorage.getItem("selectedClient"),
                    "type":"crosdoc_saleschannel",
                    "value":JSON.stringify(this.selectedsaleschannel),
                    }
              ],
                module: 'crossdock',
                localclientid: parseInt(localStorage.getItem("selectedClient")),
                warehouseidlocal: localStorage.getItem("selectedWarehouse"),
              });
            }
          }
        this.isLoading = true
        axios({
            method: 'POST',
              'url': apiUrl.api_url + 'saveconfig',
              'data': this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
        .then((response) => {
        this.isLoading = false;
        if (response.data.data.code == 0) {
            this.input1 = ({
                warehouseidlocal: localStorage.getItem("selectedWarehouse"),
                localclientid: localStorage.getItem("selectedClient"),
                productcatagory:this.selectedproductcat,
                saleschannel:this.selectedsaleschannel,
                crossdockenable :this.crossdock,
                module: 'crossdock',
            });
           return axios({
                method: 'POST',
                'url': apiUrl.api_url + 'configCrossDock',
                'data': this.input1,
                headers: {
                'Authorization': 'Bearer ' + myStr
                }
            })
          .then((response) => {
              this.isLoading = false;
              console.log(response.data.data.code);
                if (response.data.data.code == 0) {
                  this.$alertify.success(response.data.data.msg)
                  setTimeout(() => {
                    this.getconfig();
                  }, 500);
                }else if (response.data.data.code == -1) {
                  this.$alertify.error(response.data.data.msg)
                  this.getconfig();
                }
           })
          .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            })
        } else if (response.data.data.code == -1) {
          this.$alertify.error(response.data.data.msg)
        }
        })
        .catch((httpException) => {
        console.error('exception is:::::::::', httpException)
        })

   },

    // getWarehouseList() {
    //   if (window.localStorage.getItem("warehouseList") !== null) {
    //     var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
    //     var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
    //     var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
    //     this.listWarehouseData = JSON.parse(plaintextwarehouse);
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken')
    //     var myStr = userToken.replace(/"/g, '');
    //     this.isLoading = true;
    //     this.pageno = 0;

    //     this.input = ({
    //       clientid: this.localclientid,
    //     });

    //     axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr
    //       }
    //     })
    //       .then(result => {
    //         this.isLoading = false;
    //         this.listWarehouseData = result.data.data;
    //       }, error => {
    //         console.error(error)
    //       })
    //   }

    // },

    // //to get Client list
    // getClientList() {

    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     this.clientListData = JSON.parse(plaintextclient);
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     this.pageno = 0;

    //     this.input = ({
    //       warehouseid: this.localwarehouseid,
    //     });
    //     this.isLoading = true;
    //     axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr,
    //       }
    //     })
    //       .then(result => {
    //         this.clientListData = result.data.data;
    //         this.isLoading = false;
    //       }, error => {
    //         console.error(error);
    //       });
    //   }

    // },

    getRoleList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = ({})
      axios({
        method: "POST",
        url: apiUrl.api_url + "getRoleidname",
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          this.RoleListData = result.data;

        }, error => {
          console.error(error)
        })
    },

    // clientSelected() {
    //   if (this.localclientid != this.client) {
    //     this.localclientid = this.client;
    //     this.listWarehouseData = [];
    //     this.getWarehouseList();

    //    if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
    //       this.warehouse = this.localwarehouseid = '';
    //     }
    //   }

    //   this.localclientid = this.client;
    //   this.b2bqty = '';
    //   this.getProductCategory();
    //   this.getSalesChannels()

    //   if (this.localclientid) {
    //     this.getconfig();
    //     this.getconfigForEcomm();
    //     if (this.localwarehouseid) {

    //       if (this.user_type != 'system_user') {
    //         this.searchFlag = true;
    //       } else {
    //         this.searchFlag = false;
    //       }

    //     } else {
    //       this.getWarehouseList();

    //     }
      // }

      // setTimeout(() => {
      //   this.changeEnableCrossdock()
      // }, 500);
    // },
    getProductCategory() {
      this.productcategory = [];
      this.listProductCategory = [];
      this.pcount= 0;
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.user_type == "client_user") {
				this.input = ({
					clientid: this.clientid
				})
			} else {
				this.input = ({
					clientid: this.client,
				});
			}

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductCategory',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {

					this.listProductCategory = result.data.data;

          for ( var item in this.listProductCategory ){
              this.productcategory.push( this.listProductCategory[ item ] );
              this.productcategory[ item ].isselected = false;
          }

				}, error => {
					console.error(error);
				});

		},
    async getSpecialInstruction(){
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      await axios({
        method: 'POST',
				'url': apiUrl.api_url + 'getSpecialPackingInstruction',
				'data': {
					clientid: window.localStorage.getItem('selectedClient')
				},
        headers: {
          'Authorization': 'Bearer ' + myStr,
        },
         })
         .then((response) => {
          this.specialInstructionList = Array.isArray(response.data.data.data) ? response.data.data.data : [];
          this.specialInstructionCount=this.specialInstructionList.length
         })
         .catch((httpException) => {
           console.error('exception is:::::::::', httpException)
         }); 
   },
    getSalesChannels() {
      this.salesChannel = [];
      this.scount= 0;
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.clientid == '') {
				this.WarehouseErr = this.$t('srReport.clientError');
				return false;
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderSalesChannelList',
				'data': {
					clientid: this.client
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.channellist = result.data.data;
          for ( var item in this.channellist ){
            this.salesChannel.push( this.channellist[ item ] )
            this.salesChannel[ item ].isselected = false;
          }
				}, error => {
					console.error(error);
				});
		},
    // warehouseSelected() {
    //   this.localwarehouseid = this.warehouse;
    //   if (this.localwarehouseid) {
    //     if (this.localclientid) {
    //       this.getconfig();
    //       this.searchFlag = true;

    //     } else {
    //       this.getconfig();
    //       this.getClientList();
    //     }
    //   }
    // },

    updatevalue() {
      var picktype = this.pickingtype;
      if (picktype == "cluster") {
        this.showBatch = false;
      } else {
        this.showBatch = true;
      }
      console.log(this.pickingData);
      if (this.pickingData.hasOwnProperty(picktype)) {
        this.pickingtype = this.pickingData[picktype].type;
        this.pickingsize = this.pickingData[picktype].pickingsize;
        this.flag = this.pickingData[picktype].flag;
        this.status = this.pickingData[picktype].status;
        this.defaultsize = this.pickingData[picktype].defaultval;
        this.maxval = this.pickingData[picktype].maxval;
        this.autocreate = this.pickingData[picktype].autocreate;
        this.maximumvalue = this.pickingData[picktype].maximumvalue;
      } else {
        this.pickingtype = picktype;
        this.pickingsize = '';
        this.flag = "";
        this.status = "";
        this.defaultsize = "";
        this.maxval = "";
        this.autocreate = "";
        this.maximumvalue = "";
      }

    },
    updateCluster() {
      var picktype = this.pickingtype;
      if (picktype == "cluster") {
        if(this.flag == 'yes'){
          this.showDefault = true;
        }else{
          this.showDefault = false;
          this.maxval = "";
          this.defaultsize = "";
        }
      }else{
        this.showDefault = true;
      }

    },

    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    },

    saveconfig() {

      if (this.pickingtype == '' || this.pickingtype == undefined ||
        this.flag == '' || this.flag == undefined) { } else {
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        var picktype = this.pickingtype;

        var errorFlag = false;

        if (this.showBatch == true) {
          if (this.pickingsize <= 0) {
            this.showpicksizeerror = this.pickingtype + this.$t('config.sizeLessthanZero');
            errorFlag = true;
          } else if (this.flag == '') {
            this.showflagerror = this.$t('config.selectFlagOption');
            errorFlag = true;
          } else if (parseInt(this.defaultsize) >= parseInt(this.maximumvalue)) {
            this.showdefaultsizeerror = this.$t('config.defaultSizeGreaterEqual');
            errorFlag = true;
          } else if (this.defaultsize < 1) {
            this.showdefaultsizeerror = this.$t('config.defaultSizeLessOne');
            errorFlag = true;
          } else if (parseInt(this.maxval) < parseInt(this.defaultsize)) {
            this.showdefaultsizeerror = this.$t('config.defaultsizeLessthanMin');
            errorFlag = true;
          } else if (parseInt(this.maxval) > parseInt(this.maximumvalue)) {
            this.showdefaultsizeerror = this.$t('config.defaultsizeNotmorethanBatch');
            errorFlag = true;
          } else if (this.autocreate == "") {
            this.showautocreateerror = this.$t('config.selectAnOption');
            errorFlag = true;
          } else if (this.maximumvalue == "") {
            this.showmaximumvalueerror = this.$t('config.enterValueErr');
            errorFlag = true;
          } else if (parseInt(this.maximumvalue) < parseInt(this.maxval)) {
            this.showmaximumvalueerror = this.$t('config.maxCannotLessthanDefault');
            errorFlag = true;
          } else {
            this.showdefaultsizeerror = '';
            this.showpicksizeerror = '';
            this.showmaximumvalueerror = '';
            errorFlag = false;
          }
        } else {

          if (this.pickingtype == '') {
            this.showpickingtypeerror =  this.$t('config.selectpickingtype');
            errorFlag = true;
          } else if (this.flag == '') {
            this.showflagerror = this.$t('config.selectFlagOption');
            errorFlag = true;
          } else if (parseInt(this.pickingsize) <= 0) {
            this.showpickingsizeerror = this.pickingtype + this.$t('config.sizeNotlessthanOne');
            errorFlag = true;
          } else if (parseInt(this.maxval) <= 0) {
            this.showdefaultsizeerror = this.$t('config.defaultSizeLessOne');
            errorFlag = true;
          } else if (parseInt(this.pickingsize) < parseInt(this.maxval)) {
            this.showdefaultsizeerror = this.$t('config.sizeNotGreaterthanCluster')
            errorFlag = true;
          } else {
            this.showdefaultsizeerror = '';
            this.showpicksizeerror = '';
            this.showmaximumvalueerror = '';
            errorFlag = false;
          }
        }
        if (errorFlag == false) {
          this.showdefaultsizeerror = '';
          this.showpicksizeerror = '';
          this.showmaximumvalueerror = '';

          if (localStorage.getItem("selectedClient") == "") {
            this.input = ({
              config: [{
                "warehouseid": localStorage.getItem("selectedWarehouse"),
                "type": this.pickingtype,
                "value": this.pickingsize,
                "status": "active",
                "flag": this.flag,
                "defaultval": this.defaultsize,
                "maxval": this.maxval,
                "autocreate": this.autocreate,
                "maximumvalue": this.maximumvalue,
              }],
              module: 'outbound',
              warehouseidlocal:localStorage.getItem("selectedWarehouse"),
            });

          } else {
            this.input = ({
              config: [{
                "warehouseid": localStorage.getItem("selectedWarehouse"),
                "clientid": localStorage.getItem("selectedClient"),
                "type": this.pickingtype,
                "value": this.pickingsize,
                "status": "active",
                "flag": this.flag,
                "defaultval": this.maxval,
                "maxval": this.maxval,
                "autocreate": this.autocreate,
                "maximumvalue": this.maximumvalue,
              }],
              module: 'outbound',
              warehouseidlocal: Number(localStorage.getItem("selectedWarehouse")),
              //localclientid: this.localclientid,
            });
          }

          this.isLoading = true;
          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'saveconfig',
            'data': this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          })
            .then((response) => {
              if (response.data.data.code == 0) {
                this.getconfig();
                this.isLoading = false;
                this.showBatch = true;

                this.$alertify.success(response.data.data.msg);
              } else if (response.data.data.code == -1) {
                this.isLoading = false;
                this.$alertify.error(response.data.data.msg)
              }
            })
            .catch((httpException) => {
              console.error('exception is:::::::::', httpException)
            })
        } else {
          return false;
        }
      }
    },

    saveconfigaudit() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (this.sessiontime <= 0) {
        this.audit = true;
        return false;

      }
      if (this.excessqty === "") {
        this.excessqtyError = true;
        return false;
      }
      if (this.excessprodqty === "") {
        this.excessprodqtyError = true;
        return false;
      }
      if (this.sessiontime.length > 2) {
        this.audit = true;
        return false;
      }
      if (this.sessiontime === "") {
        this.audit = true;
        return false;
      } else if (this.audittime == "" || this.audittime <= 0 || this.audittime > 100) {
        this.errorAuditHour = true;
        return false;
      } else {
        this.audit = false;
        if (localStorage.getItem("selectedClient") == "") {
          this.input = ({
            config: [{
              "warehouseid": localStorage.getItem("selectedWarehouse"),
              "type": 'audit_session_time',
              "value": this.sessiontime,
              "defaultval": this.audittime,
              "maximumvalue": this.excessqty,
              "maxval": this.excessprodqty,
            }],
            module: 'rackaudit',
            warehouseidlocal: localStorage.getItem("selectedWarehouse"),
          });

        } else {
          this.input = ({
            config: [{
              "warehouseid": localStorage.getItem("selectedWarehouse"),
              "defaultval": this.audittime,
              "type": 'audit_session_time',
              "value": this.sessiontime,
              "maximumvalue": this.excessqty,
              "maxval": this.excessprodqty,
            }],
            module: 'rackaudit',
            warehouseidlocal: localStorage.getItem('selectedWarehouse'),
            //localclientid: parseInt(this.localclientid),
          });

        }
        this.isLoading = true
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              this.errorAuditHour = false;
              //this.getconfig();
              document.getElementById('sessiontime').value = '';
              //this.getconfig();
              this.isLoading = false;
              document.getElementById('audittime').value = this.audittime;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }

    },

    savePickerAssignmentType() {

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var assigntype = this.assigntype;

      if (this.assigntype == '') {
        this.showassigntypeerror = this.$t('config.pickerAssignmentTypeError');
      }
      else if (this.pickqtysize == '' && this.pickflag == 'yes') {
        this.showpickqtysizeerror = this.$t('config.pickingQuantityError');
      }
      else if (this.pickqtysize < 2 && this.pickflag == 'yes') {
        this.showpickqtysizeerror = this.$t('config.pickingQuantityGreaterError');
      }
      else {
        this.showassigntypeerror = '';
        // if (this.localclientid === null || this.localclientid == "") {
        //   this.input = ({
        //     config: [{
        //       "warehouseid": this.localwarehouseid,
        //       "type": 'pickerassign',
        //       "value": assigntype,
        //       "status": "active",
        //       "defaultval": 'single'
        //     }],
        //     module: 'pickerassign',
        //     warehouseidlocal: this.localwarehouseid,
        //   });
        // }
        // else
        if (this.pickflag == 'yes') {
          this.input = ({
            config: [{
              "warehouseid": localStorage.getItem("selectedWarehouse"),
              "type": 'pickqtysize',
              "value": this.assigntype,
              "status": "active",
              "defaultval": this.pickqtysize,
              "flag": this.pickflag
            }],
            module: 'pickerassign',
            warehouseidlocal: localStorage.getItem("selectedWarehouse"),
          });
        }
        else {
          this.input = ({
            config: [{
              "warehouseid": localStorage.getItem("selectedWarehouse"),
              "type": 'pickqtysize',
              "value": this.assigntype,
              "status": "active",
              "defaultval": null,
              "flag": this.pickflag
            }],
            module: 'pickerassign',
            warehouseidlocal: localStorage.getItem("selectedWarehouse"),
          });
        }
        // else {
        //   this.input = ({
        //     config: [{
        //       "warehouseid": this.localwarehouseid,
        //       //"clientid": this.localclientid,
        //       "type": 'pickerassign',
        //       "value": assigntype,
        //       "status": "active",
        //       "defaultval": 'single'
        //     }],
        //     module: 'pickerassign',
        //     warehouseidlocal: this.localwarehouseid,
        //     //localclientid: parseInt(this.localclientid),
        //   });
        // }

        this.isLoading = true;
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              this.getconfig();
              this.isLoading = false;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },

    saveEancodeFlag() {

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var eancodeFlag = this.eancodeFlag;

      if (this.eancodeFlag == '') {
        this.showEancodeError = this.$t('config.eancodeTypeError');
      }
      else {
        this.showEancodeError = '';
        
        
        this.input = ({
          config: [{
            "warehouseid": localStorage.getItem("selectedWarehouse"),
            "clientid": localStorage.getItem("selectedClient"),
            "type": 'enableManualEancode',
            "value": this.eancodeFlag,
            "status": "active",
            "defaultval": null,
            "flag": ""
          }],
          module: 'enableManualEancode',
          warehouseidlocal: localStorage.getItem("selectedWarehouse"),
          localclientid: localStorage.getItem("selectedClient"),
        });

        this.isLoading = true;
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              this.getconfig();
              this.isLoading = false;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },
    saveAutofillboxFlag() {

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      
      if (this.autofillboxFlag == '') {
        this.showAutofillboxError = this.$t('config.showAutoFillError');
      }
      else {
        this.showAutofillboxError = '';
        
        
        this.input = ({
          config: [{
            "warehouseid": localStorage.getItem("selectedWarehouse"),
            "clientid": localStorage.getItem("selectedClient"),
            "type": 'enableAutofillbox',
            "value": this.autofillboxFlag,
            "status": "active",
            "defaultval": null,
            "flag": ""
          }],
          module: 'enableAutofillbox',
          warehouseidlocal: localStorage.getItem("selectedWarehouse"),
          localclientid: localStorage.getItem("selectedClient"),
        });

        this.isLoading = true;
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              this.getconfig();
              this.isLoading = false;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },

    saveInscanConfig() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      if (this.rtoInscan === "") {
        this.rtoInscanError = true;
        return false;
      } else if (this.autoMatch === "") {
        this.autoMatchError = true;
        return false;
      } else {

        if (localStorage.getItem("selectedClient")) {
          this.input = ({
            config: [{
              "warehouseid": localStorage.getItem("selectedWarehouse"),
              //"clientid": this.localclientid,
              "type": 'rtoInscan',
              "value": this.rtoInscan,
              "status": "active",
              "defaultval": 'yes'
            }],
            module: 'rtoInscan',
            warehouseidlocal: localStorage.getItem("selectedWarehouse"),
            //localclientid: this.localclientid,
          });
        } else {
          this.input = ({
            config: [{
              "warehouseid": localStorage.getItem("selectedWarehouse"),
              "type": 'rtoInscan',
              "value": this.rtoInscan,
              "status": "active",
              "defaultval": 'yes'
            }],
            module: 'rtoInscan',
            warehouseidlocal: localStorage.getItem("selectedWarehouse"),
            //  localclientid: this.localclientid,
          });
        }

        this.isLoading = true;
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              this.saveRtoAutoMatch();
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }

    },
    saveThresholdReturns() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      if (this.expiryThreshold === "") {
        this.expiryThresholdError = true;
        return false;
      } else if (this.returnThresholdDays === "") {
        return false;
      } else {

        if (localStorage.getItem("selectedClient")) {
          this.input = ({
            config: [{
              //"warehouseid": this.localwarehouseid,
              "clientid": localStorage.getItem("selectedClient"),
              "type": 'returnsThreshold',
              "value": this.expiryThreshold,
              "status": "active",
              "defaultval": this.returnThresholdDays
            }],
            module: 'returnsThreshold',
            //warehouseidlocal: this.localwarehouseid,
            localclientid: localStorage.getItem("selectedClient"),
          });
        } else {
          this.input = ({
            config: [{
              "warehouseid": localStorage.getItem("selectedWarehouse"),
              "type": 'returnsThreshold',
              "value": this.expiryThreshold,
              "status": "active",
              "defaultval": this.returnThresholdDays
            }],
            module: 'returnsThreshold',
            //warehouseidlocal: this.localwarehouseid,
            localclientid: localStorage.getItem("selectedClient"),
          });
        }

        this.isLoading = true;
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              this.expiryThresholdError = false;
              this.isLoading = false;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }

    },

    saveMarketPlace() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      if (this.localclientid === "") {
        this.$alertify.error("Please Select A Client");
        return false;
      } else if (this.marketplace === "") {
        this.marketplaceError = true;
        return false;
      } else if (this.orderprocessing === "") {
        this.marketplaceError = false;
        this.orderprocessingError = true;
        return false;
      } else if (this.reservestock === "" || this.reservestock < 0) {
        this.orderprocessingError = false;
        this.reservestockError = true;
        return false;
      } else if (this.smartrack === "") {
        this.smartrackError = true;
        return false;
      } else if (this.manifestlimit === "" || this.manifestlimit < 0 || this.manifestlimit > 2000) {
        this.manifestError = true;
        return false;
      } else if (this.multimerchant === "") {
        this.multimerchantError = true;
        return false;
      } else if (this.enablespoc === "") {
        this.enablespocerror = true;
        return false;
      }
      else if ((this.marketplace =="unicommerce" || this.marketplace == "increff") && this.returnsIntegration === "") {
         this.returnsIntegrationError = true;
         return false;
      }
      else {

        this.input = ({
          config: [{
            "clientid": localStorage.getItem("selectedClient"),
            "type": 'marketplace',
            "value": this.marketplace,
            "status": 'active',
            "maxval": this.orderprocessing, // Order Processing
            "defaultval": this.reservestock, // Reserved Stock
            "description": this.smartrack, //Smart Rack Enable Disable
            "flag": this.manifestlimit, // Manifest Limit
            "autocreate": this.multimerchant, //Setting The multimerchant
            "returns" : this.returnsIntegration,//Setting Returns Integration
          }],
          module: 'marketplace',
          localclientid: localStorage.getItem("selectedClient"),
        });
        //console.log(this.input);return false;
        this.isLoading = true;
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              //this.getconfig();
              this.orderprocessingError = false;
              this.reservestockError = false;
              this.manifestError = false;
              this.smartrackError = false;
              this.returnsIntegrationError = false;
              this.isLoading = false;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }

    },
    saveRackPrefix() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      if (localStorage.getItem("selectedClient") === "") {
        this.$alertify.error(this.$t('apiErrors.SELECT_CLIENT'));
        return false;
      } else if (localStorage.getItem("selectedWarehouse") === "") {
        this.$alertify.error(this.$t('apiErrors.SELECT_WAREHOUSE'));
        return false;
      } else if (this.rackprefixtemp === "") {
        this.rackprefixError = true;
        this.rackError = this.$t('config.enterValueErr');
        return false;
      } else {
        this.rackprefix = this.rackprefixtemp;
        this.input = {
          "clientid": localStorage.getItem("selectedClient"),
          "warehouseid": localStorage.getItem("selectedWarehouse"),
          "module": 'rackprefix',
          "prefixname": this.rackprefix,
        }
        this.isLoading = true;
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'checkrackPrefix',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((checkresponse) => {
            if (checkresponse.data.errorCode == 0) {
              this.input = ({
                config: [{
                  "clientid": localStorage.getItem("selectedClient"),
                  "warehouseid":localStorage.getItem("selectedWarehouse"),
                  "type": 'rackprefix',
                  "value": this.rackprefix,
                  "status": 'active',
                }],
                module: 'rackprefix',
                localclientid: localStorage.getItem("selectedClient"),
                warehouseidlocal: localStorage.getItem("selectedWarehouse"),
              });

              this.isLoading = true;
              axios({
                method: 'POST',
                'url': apiUrl.api_url + 'saveconfig',
                'data': this.input,
                headers: {
                  'Authorization': 'Bearer ' + myStr
                }
              })
                .then((response) => {
                  if (response.data.data.code == 0) {
                    this.getconfig();
                    this.rackprefixError = false;
                    this.rackError = "";
                    this.isLoading = false;
                    this.$alertify.success(response.data.data.msg);
                  } else if (response.data.data.code == -1) {
                    this.isLoading = false;
                    this.$alertify.error(response.data.data.msg)
                  }
                })
                .catch((httpException) => {
                  console.error('exception is:::::::::', httpException)
                })
            } else {
              this.isLoading = false;
              this.rackprefixError = true;
              this.rackError = "This Value Already Exists For Other Combinations";
              return false;
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },

    saveFcWarehouse() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        config: [{
          "clientid": localStorage.getItem("selectedClient"),
          "type": 'fcwarehouse',
          "value": this.fcwarehouse,
          "status": "active",
          "defaultval": 'no',
          "flag": this.routingenabled
        }],
        module: 'fcwarehouse',
        localclientid: localStorage.getItem("selectedClient"),
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data.code == 0) {

            this.isLoading = false;
            this.$alertify.success(response.data.data.msg);
          } else if (response.data.data.code == -1) {
            this.isLoading = false;
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })


    },

    saveRtoAutoMatch() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        config: [{
          "warehouseid": localStorage.getItem("selectedWarehouse"),
          "type": 'autoMatch',
          "value": this.autoMatch,
          "status": "active",
          "defaultval": 'no'
        }],
        module: 'auto_match',
        warehouseidlocal: localStorage.getItem("selectedWarehouse"),
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data.code == 0) {
            this.getconfig();
            this.isLoading = false;
            this.$alertify.success(response.data.data.msg);
          } else if (response.data.data.code == -1) {
            this.isLoading = false;
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })


    },

    saveDRCheckRackin() {

      if (this.enabledrcheck == "") {
        this.enabledrcheckerror = this.$t('config.selectAnOption');
        return false;
      }
      else {
        this.isLoading = true;
        this.enabledrcheckerror = "";
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = ({
          config: [{
            "warehouseid": localStorage.getItem("selectedWarehouse"),
            "clientid": localStorage.getItem("selectedClient"),
            "type": 'drcheckrackin',
            "value": this.enabledrcheck,
            "status": "active",
            "defaultval": 'no'
          }],
          module: 'drcheckrackin',
          localclientid: localStorage.getItem("selectedClient"),
          warehouseidlocal: localStorage.getItem("selectedWarehouse"),
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              this.getconfig();
              this.enabledrcheckerror = "";
              this.isLoading = false;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.getconfig();
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }



    },

    saveMultiRackValidationRackin() {

      if (this.enablemultirackcheck == "") {
        this.enablemultirackcheckerror = this.$t('config.selectAnOption');
        return false;
      }
      else {
        this.isLoading = true;
        this.enablemultirackcheckerror = "";
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = ({
          config: [{
            "warehouseid": localStorage.getItem("selectedWarehouseid"),
            "type": 'doublerackcheck',
            "value": this.enablemultirackcheck,
            "status": "active",
            "defaultval": 'no'
          }],
          module: 'doublerackcheck',
          warehouseidlocal: Number(localStorage.getItem("selectedWarehouseid")),
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              //this.getconfig();
              this.enablemultirackcheckerror = "";
              this.isLoading = false;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },

    saveSubinventorycheck() {

      if (this.enablesubinvcheck == "") {
        this.enablesubinvcheckerror = this.$t('config.selectAnOption');
        return false;
      }
      else {
        this.isLoading = true;
        this.enablesubinvcheckerror = "";
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = ({
          config: [{
            "clientid": localStorage.getItem("selectedClient"),
            "warehouseid": localStorage.getItem("selectedWarehouseid"),
            "type": 'Subinventorycheck',
            "value": this.enablesubinvcheck,
            "status": "active",
            "defaultval": 'no'
          }],
          module: 'Subinventorycheck',
          warehouseidlocal: Number(localStorage.getItem("selectedWarehouseid")),
          localclientid: Number(localStorage.getItem("selectedClient"))
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              //this.getconfig();
              this.enablemultirackcheckerror = "";
              this.isLoading = false;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },
    saveAutoDrclose(){
      if (this.enableautodrclose == "") {
        this.enableautodrcloseerror = this.$t('config.selectAnOption');
        return false;
      }
      else {
        this.isLoading = true;
        this.enablesubinvcheckerror = "";
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = ({
          config: [{
            "clientid": localStorage.getItem("selectedClient"),
            "warehouseid": localStorage.getItem("selectedWarehouseid"),
            "type": 'enableautodrclose',
            "value": this.enableautodrclose,
            "status": "active",
            "defaultval": 'no'
          }],
          module: 'enableautodrclose',
          warehouseidlocal: Number(localStorage.getItem("selectedWarehouseid")),
          localclientid: Number(localStorage.getItem("selectedClient"))
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              //this.getconfig();
              this.enableautodrcloseerror = "";
              this.isLoading = false;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },
    saveReceiptQtytolerances() {
      if (this.Tolerancepercentage < 0) {
        return false;
      }
      if (this.Tolerancepercentage > 100) {
        return false;
      }
      if (this.roleid == '' || this.Tolerancepercentage == '') {
        this.roleiderror = "Please Fill all Records";
        return false;
      }
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (this.localclientid === null || this.localclientid == "") {
        this.input = ({
          config: [{
            "warehouseid":localStorage.getItem("selectedWarehouse"),
            "value": this.Tolerancepercentage,
            "defaultval": this.roleid,
            "status": 'active',
            "type": 'potolerance'
          }],
          module: 'potolerance',
          warehouseidlocal: localStorage.getItem("selectedWarehouse"),
        });

      } else {
        this.input = ({
          config: [{
            "warehouseid": localStorage.getItem("selectedWarehouse"),
            //"clientid": this.localclientid,
            "value": this.Tolerancepercentage,
            "defaultval": this.roleid,
            "status": 'active',
            "type": 'potolerance'
          }],
          module: 'potolerance',
          warehouseidlocal: localStorage.getItem("selectedWarehouse"),
          //localclientid: parseInt(this.localclientid),
        });
      }

      this.isLoading = true
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data.code == 0) {
            document.getElementById('Tolerancepercentage').value = '';
            document.getElementById('roleid').value = '';
            this.getconfig();
            this.isLoading = false;
            this.$alertify.success(response.data.data.msg);
          } else if (response.data.data.code == -1) {
            this.isLoading = false
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })

    },
    checkValidationForPickAssign() {
      if (this.pickflag == 'yes') {
        if (parseInt(this.pickqtysize) < 1) {
          this.showpickqtysizeerror = this.$t('config.defaultSizeLessOne');
        }
        else {
          this.showpickqtysizeerror = ''
        }
      }
    },

    checkValidation() {
      if (this.showBatch == true) {
        if (this.pickingtype == '') {
          this.showpickingtypeerror = this.$t('config.selectpickingtype');
        } else if (this.flag == '') {
          this.showflagerror = this.$t('config.selectFlagOption');
        } else if (parseInt(this.pickingsize) <= 0) {
          this.showpickingsizeerror = this.pickingtype + this.$t('config.sizeLessthanZero');
        } else if (parseInt(this.defaultsize) < 1) {
          this.showdefaultsizeerror = this.$t('config.defaultSizeLessOne');
        } else if (parseInt(this.maximumvalue) < parseInt(this.maxval)) {
          this.showmaximumvalueerror = this.$t('config.maxCannotLessthanDefault');
        } else if (parseInt(this.maxval) < parseInt(this.defaultsize)) {
          this.showdefaultsizeerror = this.$t('config.defaultsizeLessthanMin');
        } else if (parseInt(this.maxval) > parseInt(this.maximumvalue)) {
          this.showdefaultsizeerror = this.$t('config.defaultSizenotMorethanMax');
        } else if (this.autocreate == "") {
          this.showautocreateerror = this.$t('config.selectAnOption');
        } else if (this.maximumvalue == "") {
          this.showmaximumvalueerror =  this.$t('config.enterValueErr');
        } else {
          this.showdefaultsizeerror = '';
          this.showpickingsizeerror = '';
          this.showautocreateerror = '';
          this.showmaximumvalueerror = '';
        }
        if (parseInt(this.b2bqty) <= 1) {
          this.b2bqtyError = this.$t('config.thresholdLessthanOne');
        } else {
          this.b2bqtyError = '';
        }

      } else {
        if (this.pickingtype == '') {
          this.showpickingtypeerror = this.$t('config.selectpickingtype');
        } else if (this.flag == '') {
          this.showflagerror = this.$t('config.selectFlagOption');
        } else if (parseInt(this.pickingsize) <= 0) {
          this.showpickingsizeerror = this.pickingtype +  this.$t('config.sizeNotlessthanOne');
        } else if (parseInt(this.maxval) <= 0) {
          this.showdefaultsizeerror = this.$t('config.defaultSizeLessOne');
        } else if (parseInt(this.pickingsize) < parseInt(this.maxval)) {
          this.showdefaultsizeerror = this.$t('config.sizeNotGreaterthanCluster');
        } else {
          this.showdefaultsizeerror = '';
          this.showpickingsizeerror = '';
          this.showautocreateerror = '';
          this.showmaximumvalueerror = '';
        }
        if (parseInt(this.b2bqty) <= 1) {
          this.b2bqtyError = this.$t('config.thresholdLessthanOne');
        } else {
          this.b2bqtyError = '';
        }


      }

    },

    setTimeFunction() {
      document.getElementById("b2bqty").value = '';
      return true;
    },

    getconfig() {

      if (this.searchFlag == true && localStorage.getItem("selectedWarehouseid") && this.user_type != 'system_user') {
        document.getElementById("pickingsize").value = "";
        if (this.showBatch == true) {
          document.getElementById("defaultsize").value = "";
        }

        document.getElementById("cluster").checked = false;
        document.getElementById("batch").checked = false;
        //setTimeout(this.setTimeFunction, 1000);

      }

      // if(this.client!="")
      // {
      //     setTimeout(() => document.getElementById("expcount").value = "", 10);
      // }
      this.resetForm();
      this.assigntype = '';
      this.rtoInscan = '';
      this.mrpchecknew = '';
      this.expirycheck = '';
      this.expcount = '';
      this.b2bqty = '';
      //document.getElementById("b2bqty").value = '';


      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getconfig',
        'data': {
          warehouseidlocal: localStorage.getItem("selectedWarehouse"),
          localclientid: localStorage.getItem("selectedClient"),
        },
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          console.log(response, "response");
          this.searchFlag = true;
          if (response.data.length) {
            this.setconfig(response.data, "outbound");
            this.setconfig(response.data, "pickerassign");
            this.setconfig(response.data, "rtoInscan");
            this.setconfig(response.data, "rackaudit");
            this.setconfig(response.data, "potolerance");
            this.setconfig(response.data, "order_mrp_check");
            this.setconfig(response.data, "order_exp_check");
            this.setconfig(response.data, "print_invoice_ONOFF");
            this.setconfig(response.data, "client_logo");
            this.setconfig(response.data, "customer_acknowledgement");
            this.setconfig(response.data, "return_policy");
            this.setconfig(response.data, "terms_and_conditions");
            this.setconfig(response.data, "office_address");
            this.setconfig(response.data, "customer_care_phone");
            this.setconfig(response.data, "customer_care_email");
            this.setconfig(response.data, "ecommercexb");
            this.setconfig(response.data, "partial_order");
            this.setconfig(response.data, "print_label_ONOFF");
            this.setconfig(response.data, "auto_match");
            this.setconfig(response.data, "marketplace");
            this.setconfig(response.data, "rackprefix");
            this.setconfig(response.data, "drcheckrackin");
            this.setconfig(response.data, "threshold_order_qty");
            this.setconfig(response.data, "doublerackcheck");
            this.setconfig(response.data, "returnsThreshold");
            this.setconfig(response.data, "Subinventorycheck");
            this.setconfig(response.data, "packingbox");
            this.setconfig(response.data, "fcwarehouse");
            this.setconfig(response.data, "upload_invoice_dr");
            this.setconfig(response.data, "split_box");
            this.setconfig(response.data, "activemrp");
            this.setconfig(response.data, "batch");
            this.setconfig(response.data, "cluster");
            this.setconfig(response.data, "enableCrossdock");
            this.setconfig(response.data, "crosdoc_categories");
            this.setconfig(response.data, "crosdoc_saleschannel");
            this.setconfig(response.data, "enableManualEancode");
            this.setconfig(response.data, "enableAutofillbox");
            this.setconfig(response.data, "enableautodrclose");
            this.setconfig(response.data, "spokenabled");
          } else {
            this.resetForm();
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    setconfig(response, moduleType) {
      if (moduleType == 'outbound') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'outbound') {
            this.pickingData[response[i].type] = '';
            this.pickingData[response[i].type] = {
              "type": response[i].type,
              "pickingsize": response[i].value,
              "flag": response[i].flag,
              "status": response[i].status,
              "defaultval": response[i].defaultval,
              "maxval": response[i].maxval,
              "autocreate": response[i].autocreate,
              "maximumvalue": response[i].maximumvalue,
            }


          }
        }
        //console.log(this.pickingData);
        Object.entries(this.pickingData).forEach(([key, val]) => {
          this.pickingtype = val.type;
          this.pickingsize = val.pickingsize;
          this.flag = val.flag;
          this.status = val.status;
          this.defaultsize = val.defaultval;
          this.maxval = val.maxval;
          this.autocreate = val.autocreate;
          this.maximumvalue = val.maximumvalue;
        });
        //console.log(this.pickingData);
      }
      // if (moduleType == 'pickerassign') {
      //   for (var i = 0; i < response.length; i++) {
      //     if (response[i].module == 'pickerassign') {
      //       this.assigntype = response[i].value;
      //       this.pickflag = response[i].flag;
      //       this.pickqtysize = response[i].defaultval;
      //     }
      //   }
      // }
      if (moduleType == 'pickerassign') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].type == 'pickqtysize') {
            this.assigntype = response[i].value;
            this.pickflag = response[i].flag;
            this.pickqtysize = response[i].defaultval;
          }
        }
      }
      if (moduleType == 'rackaudit') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'rackaudit') {
            this.sessiontime = response[i].value;
            this.audittime = response[i].defaultval;
            this.excessqty = response[i].maximumvalue;
            this.excessprodqty = response[i].maxval;
          }
        }
      }
      if (moduleType == 'marketplace') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'marketplace') {
            this.marketplace = response[i].value;
            this.reservestock = response[i].defaultval;
            this.orderprocessing = response[i].maxval;
            this.smartrack = response[i].description;
            this.manifestlimit = response[i].flag;
            this.multimerchant = response[i].autocreate;
            this.returnsIntegration = response[i].returns;
          }
        }
      }
      if (moduleType == 'rackprefix') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'rackprefix') {
            this.rackprefix = response[i].value;
            if (response[i].value !== null) {
              this.hasPrefix = true;
            }
          }
        }
      }
      if (moduleType == 'rtoInscan') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'rtoInscan') {
            this.rtoInscan = response[i].value
          }
        }
      }
      if (moduleType == 'fcwarehouse') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'fcwarehouse') {
            this.fcwarehouse = response[i].value
            this.routingenabled = response[i].flag;
          }
        }
      }
      if (moduleType == 'drcheckrackin') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'drcheckrackin') {
            this.enabledrcheck = response[i].value
          }
        }
      }
      if (moduleType == 'returnsThreshold') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'returnsThreshold') {
            this.expiryThreshold = response[i].value
            this.returnThresholdDays = response[i].defaultval
          }
        }
      }
      if (moduleType == 'doublerackcheck') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'doublerackcheck') {
            this.enablemultirackcheck = response[i].value
          }
        }
      }
      if (moduleType == 'potolerance') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'potolerance') {
            this.roleid = response[i].defaultval,
              this.Tolerancepercentage = response[i].value
          }
        }
      }
      if (moduleType == 'order_mrp_check') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'order_mrp_check') {
            this.mrpchecknew = response[i].flag;
          }
        }
      }
      if (moduleType == 'order_exp_check') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'order_exp_check' && this.expirycheck == "") {
            this.expirycheck = response[i].flag;
            this.expcount = parseInt(response[i].value);
            document.getElementById('expcount').value = response[i].value;
          }

        }
      }
      if (moduleType == 'ecommercexb') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'ecommercexb') {
            this.ecommxb = response[i].value;
          }

        }
      }
      if (moduleType == 'partial_order') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'partial_order') {
            this.partialorder = response[i].flag;
          }

        }
      }
      if (moduleType == 'packingbox') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'packingbox') {
            this.packingbox = response[i].value;
          }

        }
        console.log(this.packingbox, "packingbox");
      }
      if (moduleType == 'Subinventorycheck') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'Subinventorycheck') {
            this.enablesubinvcheck = response[i].value;
          }

        }
      }
      if (moduleType == 'print_invoice_ONOFF') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'customer_invoice' && response[i].type == 'print_invoice_ONOFF') {
            this.enableInvoice = response[i].flag == 'yes' ? true : false;
          }

        }
      }
      if (moduleType == 'print_label_ONOFF') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'customer_invoice' && response[i].type == 'print_label_ONOFF') {
            this.enableLabel = response[i].flag == 'yes' ? true : false;
          }

        }
      }
      if (moduleType == 'auto_match') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'auto_match') {
            if (response[i].value != "") {
              this.autoMatch = response[i].value;
            } else {
              this.autoMatch = 'no';
            }

          }

        }
      }
      if (moduleType == 'client_logo') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'customer_invoice' && response[i].type == 'client_logo') {
            document.getElementById('file').value = '';
            this.logoname = response[i].value;
          }

        }
      }
      if (moduleType == 'customer_acknowledgement') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'customer_invoice' && response[i].type == 'customer_acknowledgement') {
            this.custAcknowled = response[i].value;
          }

        }
      }
      if (moduleType == 'return_policy') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'customer_invoice' && response[i].type == 'return_policy') {
            this.returnPolicy = response[i].value;
          }

        }
      }
      if (moduleType == 'terms_and_conditions') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'customer_invoice' && response[i].type == 'terms_and_conditions') {
            this.tandc = response[i].value;
          }

        }
      }
      if (moduleType == 'office_address') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'customer_invoice' && response[i].type == 'office_address') {
            this.officeAddress = response[i].value;
          }

        }
      }
      if (moduleType == 'customer_care_phone') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'customer_invoice' && response[i].type == 'customer_care_phone') {
            this.ccphone = response[i].value;
            document.getElementById('ccphone').value = response[i].value;
          }

        }
      }
      if (moduleType == 'customer_care_email') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'customer_invoice' && response[i].type == 'customer_care_email') {
            document.getElementById('ccemail').value = '';
            this.ccemail = response[i].value;
            document.getElementById('ccemail').value = response[i].value;
          }

        }
      }
      if (moduleType == 'threshold_order_qty') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'threshold_order_qty') {
            this.b2bqty = '';
            document.getElementById('b2bqty').value = '';

            if (response[i].value != '') {
              this.b2bqty = response[i].value;
              document.getElementById('b2bqty').value = response[i].value;
            } else {
              this.b2bqty = '';
              document.getElementById('b2bqty').value = '';
            }
          }
        }
      }
      if (moduleType == 'upload_invoice_dr') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'customer_invoice' && response[i].type == 'upload_invoice_dr') {
            this.uploadinvoice = response[i].value;
          }
        }
      }
      if (moduleType == 'activemrp') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'activemrp') {
            this.activemrp = response[i].value;
          }

        }
      }
      if (moduleType == 'split_box') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'split_box') {
            this.splitbox = response[i].value;
          }

        }
      }
      if (moduleType == 'outbound') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'outbound') {
            this.pickingtype = response[i].type;
             console.log(this.pickingtype);
            var picktype = this.pickingtype;
              if (picktype == "cluster") {
                this.showBatch = false;
              } else {
                this.showBatch = true;
              }
            this.pickingsize = response[i].value;
            this.flag = response[i].flag;
            this.status = response[i].status;
            this.defaultsize = response[i].defaultval;
            this.maxval = response[i].maxval;
            this.autocreate = response[i].autocreate;
            this.maximumvalue = response[i].maximumvalue;

          }

        }
      }

      if (moduleType == 'enableCrossdock') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'crossdock' && response[i].type == 'enableCrossdock') {
            if (this.client && this.warehouseid) {
                if (Number(localStorage.getItem("selectedWarehouse")) === response[i].warehouseid) {
                  this.crossdock = response[i].value;
                }
               } else if (this.client && (localStorage.getItem("selectedWarehouse"=="undefined"))) {
                  if(this.client === response[i].clientid && response[i].warehouseid === null){
                    this.crossdock = response[i].value;
                  }
                }

          }
        }
        if(!this.crossdock){
          this.crossdock = 'no'
        }
      }
      if (moduleType == 'crosdoc_categories') {
        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'crossdock' && response[i].type == 'crosdoc_categories') {
              if (this.client && this.warehouseid) {

                if(Number(localStorage.getItem("selectedWarehouse")) === response[i].warehouseid){
                console.log("fbwihesafohoa")
                  var inputString = response[i].value;
                  var categoryArray = JSON.parse(inputString);
                    var resultArray = categoryArray.map(item => ({
                      "productcategory": item,
                      "isselected": true
                  }));

                  this.pcount =0;
                  const nonExistingElements = this.resultproductCategory.filter(cat => {
                    return !resultArray.some(result => result.productcategory === cat.productcategory);
                  });

                  nonExistingElements.forEach(cat => {
                    cat.isselected = false;
                  });
                  resultArray.forEach(result => {
                    let existingCat = this.resultproductCategory.find(s => s.productcategory === result.productcategory);
                    const resultString = result.productcategory;
                   if (existingCat) {
                      existingCat.isselected = true;
                      this.pcount++;
                      if (!this.selectedproductcat.includes(resultString)) {
                        this.selectedproductcat.push(resultString);
                      }
                    }
                    // console.log(resultArray)
                  });

              }
          } else if (this.client && localStorage.getItem("selectedWarehouse")){
              if(this.client === response[i].clientid && response[i].warehouseid === null){
                 var inputString = response[i].value;
                var categoryArray = JSON.parse(inputString);
                var resultArray = categoryArray.map(item => ({
                  "productcategory": item,
                  "isselected": true
                }));
                const nonExistingElements = this.resultproductCategory.filter(cat => {
                  return !resultArray.some(result => result.productcategory === cat.productcategory);
                });
                nonExistingElements.forEach(cat => {
                  cat.isselected = false;
                });
                this.pcount =0;
                resultArray.forEach(result => {
                  let existingCat = this.resultproductCategory.find(s => s.productcategory === result.productcategory);
                  const resultString = result.productcategory;
                  if (existingCat) {
                    existingCat.isselected = true;
                    this.pcount += 1;
                    if(!this.selectedproductcat.includes(resultString)){
                      this.selectedproductcat.push(resultString);
                    }
                  }
                });
              }

            }

          }

        }
      }

      if (moduleType == 'crosdoc_saleschannel') {

        for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'crossdock' && response[i].type == 'crosdoc_saleschannel') {
            console.log(response[i].module)
            console.log(response[i].type);
            console.log(response[i].warehouseid);
            console.log(response[i].clientid);
            console.log("hgdawtydfuasudta  "+i);
            this.selectedsaleschannel = [];
            if(this.client && this.warehouseid){
              if(Number(localStorage.getItem("selectedWarehouse")) === response[i].warehouseid){
                var inputString1 = response[i].value;
                var channelArray = JSON.parse(inputString1);
                var resultArray1 = channelArray.map(item => ({
                  "saleschannel": item,
                  "isselected": true
                }));
                const nonExistingSalesElements = this.resultsalesChannel.filter(sale => {
                  return !resultArray1.some(result => result.saleschannel === sale.saleschannel);
                });
                nonExistingSalesElements.forEach(sale => {
                  sale.isselected = false;
                });
                this.scount =0;
                resultArray1.forEach(result1 => {
                  let existingChannel = this.resultsalesChannel.find(s => s.saleschannel === result1.saleschannel);
                  const resultSaleString = result1.saleschannel;
                  // console.log(resultSaleString);

                 if (existingChannel) {
                    existingChannel.isselected = true;
                    this.scount += 1;
                    if(!this.selectedsaleschannel.includes(result1)){
                      this.selectedsaleschannel.push(resultSaleString);
                    }
                  }
                });

              }

              }else if (this.client && (localStorage.getItem("selectedWarehouse"))) {
                if(this.client === response[i].clientid && response[i].warehouseid === null){

                  var inputString1 = response[i].value;
                  var channelArray = JSON.parse(inputString1);
                  var resultArray1 = channelArray.map(item => ({
                    "saleschannel": item,
                    "isselected": true
                  }));
                  const nonExistingSalesElements = this.resultsalesChannel.filter(sale => {
                    return !resultArray1.some(result => result.saleschannel === sale.saleschannel);
                  });
                  nonExistingSalesElements.forEach(sale => {
                    sale.isselected = false;
                  });

                  this.scount =0;
                  resultArray1.forEach(result1 => {
                    let existingChannel = this.resultsalesChannel.find(s => s.saleschannel === result1.saleschannel);
                    const resultSaleString = result1.saleschannel;
                    //console.log(resultSaleString);

                   if (existingChannel) {
                      existingChannel.isselected = true;
                      this.scount += 1;
                      if(!this.selectedsaleschannel.includes(result1)){
                        this.selectedsaleschannel.push(resultSaleString);

                      }

                    }
                  });
                }


              }
            }


        }
      }

      if(moduleType == 'enableManualEancode')
      {
         for (var i = 0; i < response.length; i++) {
          if (response[i].module == 'enableManualEancode') {
            this.eancodeFlag = response[i].value;
          }

        }
      }
      if(moduleType == 'enableAutofillbox')
        {
           for (var i = 0; i < response.length; i++) {
            if (response[i].module == 'enableAutofillbox') {
              this.autofillboxFlag = response[i].value;
            }
  
          }
        }
        if(moduleType == 'enableautodrclose')
          {
             for (var i = 0; i < response.length; i++) {
              if (response[i].module == 'enableautodrclose') {
                this.enableautodrclose = response[i].value;
              }
    
            }
          }
          if (moduleType == 'spokenabled') {
            for (var i = 0; i < response.length; i++) {
              if (response[i].module == 'spokenabled') {
                this.enablespoc = response[i].value
              }
            }
          }
    },

    resetForm() {
      this.pickingtype = '';
      this.pickingsize = '';
      this.flag = '';
      this.defaultsize = '';
      this.assigntype = '';
      this.excessqty = '';
      this.excessprodqty = '';
      this.rtoInscan = '';
      this.mrpchecknew = '';
      this.expirycheck = '';
      this.expcount = '';
      this.Tolerancepercentage = '';
      this.ecomm = '';
      this.Cname = '';
      this.enableInvoice = '';
      this.selectedImageFile = '';
      this.returnPolicy = '';
      this.custAcknowled = '';
      this.tandc = '';
      this.officeAddress = '';
      this.ccphone = '';
      this.ccemail = '';
      this.logoname = '';
      this.ecommxb = '';
      this.partialorder = '';
      this.enableLabel = '';
      this.autoMatchError = '';
      this.autoMatch = '';
      this.marketplace = '';
      this.orderprocessingError = false;
      this.reservestockError = false;
      this.orderprocessing = '';
      this.reservestock = '';
      this.rackprefixError = false;
      this.rackError = "";
      this.rackprefix = '';
      this.smartrack = '';
      this.smartrackError = false;
      this.manifestlimit = '';
      this.manifestError = false;
      this.hasPrefix = false;
      this.rackprefixtemp = '';
      this.enabledrcheck = '';
      this.enablemultirackcheck = '';
      this.enabledrcheckerror = '';
      this.enablemultirackcheckerror = '';
      this.b2bqty = '';
      this.b2bqtyError = '';
      this.expiryThreshold = '';
      this.returnThresholdDays = '';
      this.expiryThresholdError = false;
      this.fcwarehouseError = '';
      this.routingEnabledError = '';
      this.routingenabled = '',
      this.fcwarehouse = '';
      this.splitbox = '';
      this.splitboxerror = '';
      this.activemrp = 'no';
      this.$validator.reset();
      this.errors.clear();
    },
    resetCrossDock() {
      this.crossdock = '';
      for (let i = 0; i < this.resultsalesChannel.length; i++) {
        //this.selectedsaleschannel.pop(this.selectedsaleschannel[i].saleschannel);
        if(this.resultsalesChannel[i].isselected === true){
          this.resultsalesChannel[i].isselected = false
          this.scount -= 1;
          this.selectedsaleschannel.pop(this.resultsalesChannel[i].saleschannel);

        }
      }
      for (let i = 0; i < this.resultproductCategory.length; i++) {
       // this.selectedproductcat.pop(this.selectedproductcat[i].productcatagory);
        if(this.resultproductCategory[i].isselected === true){
          this.resultproductCategory[i].isselected = false
          this.pcount -= 1;
          this.selectedproductcat.pop(this.resultproductCategory[i].productcatagory);

        }

      }

    },
    onSubmit: function (event) {

      this.$validator
        .validateAll()
        .then(() => {
          console.log("form is valid", this.model);
          //event.target.reset();
        })
        .catch(() => {
          console.log("errors exist", this.errors);
        });
    },
    getCourierCompList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = ({})
      axios({
        method: "Post",
        url: apiUrl.api_url + "getCourierList",
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (result.data.ErrorCode == 0) {
            this.CourierCompList = []
            var resultList = result.data.data.rows;
            for (var i = 0; i < resultList.length; i++) {
              this.CourierCompList[i] = resultList[i].couriername
            }
          } else {
            this.$alertify.error("No Courier Company Details Found");
          }
        }, error => {
          console.error(error)
        })
    },
    saveconfigEcomm() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        config: [{
          //  "warehouseid": this.localwarehouseid,
          "clientid": localStorage.getItem("selectedClient"),
          "type": this.Cname,
          "value": this.Otype,
        }, {
          //"warehouseid": this.localwarehouseid,
          "clientid": this.localStorage.getItem("selectedClient"),
          "type": 'ecom_ONOFF',
          "value": this.ecomm,
        }],
        module: 'ecommerce',
        //warehouseidlocal: this.localwarehouseid,
        localclientid: localStorage.getItem("selectedClient")
      });
      this.isLoading = true;
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data.code == 0) {
            this.getconfig();
            this.getconfigForEcomm();
            this.isLoading = false;
            this.$alertify.success(response.data.data.msg);
          } else if (response.data.data.code == -1) {
            this.isLoading = false;
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    getconfigForEcomm() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getconfigForEcomm',
        'data': {
          localclientid: localStorage.getItem("selectedClient")
        },
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.length >= 0) {
            this.EcommList = [];
            this.Cname = '';
            this.Otype = '';
            var resultArr = response.data
            for (var i = 0; i < resultArr.length; i++) {
              if (resultArr[i].type !== "ecom_ONOFF") {
                this.EcommList.push({
                  "clientid": resultArr[i].clientid,
                  "Ecommer_On/Off": resultArr[i].flag,
                  "moduleid": resultArr[i].id,
                  "module": resultArr[i].module,
                  "shippingCompName": resultArr[i].type,
                  "type": resultArr[i].value,
                  "warehouseid": resultArr[i].warehouseid
                })
              } else {
                this.ecomm = resultArr[i].value
              }
            }
          } else {
            this.resetForm();
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    openModal(data) {
      this.removecompName = data.shippingCompName
      this.removeData = true
      this.recordToDelete = data
    },
    deleteRecord() {
      var record = this.recordToDelete
      var input = {
        localclientid: localStorage.getItem("selectedClient"),
        moduleid: record.moduleid,
        couriercompany: record.shippingCompName
      }
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'deleteRecordForEcomm',
        'data': input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response) {
            this.$alertify.success("Record Deleted Successfully")
            this.getconfigForEcomm();

          } else {
            this.$alertify.error("Something Went Wrong");
          }
          this.removeData = false;
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })

    },
    close() {
      this.removeData = false;
    },
    checkValidationForEcomm() {
      // if (this.ecomm == '') {
      //   this.ecommError = true;
      //     return false;
      // }
      // else{
      //   this.ecommError = false;
      // }
      if (this.Cname == '') {
        this.ClientErr = this.$t('config.courierCompanyErr');
        return false;
      } else {
        this.ClientErr = ''
      }
      if (this.Otype == '') {
        this.OtypeErr = this.$t('config.orderTypeErr');
        return false;
      } else {
        this.OtypeErr = '';
      }
      this.saveconfigEcomm();
    },

    saveconfigEcommOnOff() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      if (localStorage.getItem("selectedClient")=== null ) {
        this.input = ({
          config: [{
            //"warehouseid": this.localwarehouseid,
            "clientid": localStorage.getItem("selectedClient"),
            "type": 'ecom_ONOFF',
            "value": this.ecomm,
          }],
          module: 'ecommerce',
          //warehouseidlocal: this.localwarehouseid,
          localclientid: localStorage.getItem("selectedClient")
        });

      } else {
        this.input = ({
          config: [{
            //"warehouseid": this.localwarehouseid,
            "clientid": localStorage.getItem("selectedClient"),
            "type": 'ecom_ONOFF',
            "value": this.ecomm,
          }],
          module: 'ecommerce',
          //warehouseidlocal: this.localwarehouseid,
          localclientid: parseInt(localStorage.getItem("selectedClient")),
        });
      }

      this.isLoading = true;
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data.code == 0) {
            var msg = ''
            this.isLoading = false;
            if (this.ecomm == "yes") {
              msg = "On"
              this.$alertify.success("Ecom Service is" + " " + msg + " now");
            } else {
              msg = "Off"
              this.$alertify.error("Ecom Service is" + " " + msg + " now");
            }

          } else if (response.data.data.code == -1) {
            this.isLoading = false;
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    saveconfigEcommXBOnOff() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        config: [{
          "clientid": localStorage.getItem("selectedClient"),
          "type": 'ecom_ONOFFXB',
          "value": this.ecommxb,
        }],
        module: 'ecommercexb',
        localclientid: parseInt(localStorage.getItem("selectedClient")),
      });


      this.isLoading = true;
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveconfig',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data.code == 0) {
            var msg = ''
            this.isLoading = false;
            if (this.ecommxb == "yes") {
              msg = "On"
              this.$alertify.success("Ecom-XB Service is" + " " + msg + " now");
            } else {
              msg = "Off"
              this.$alertify.error("Ecom-XB Service is" + " " + msg + " now");
            }

          } else if (response.data.data.code == -1) {
            this.isLoading = false;
            this.$alertify.error(response.data.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    confirmationDeleteSpecialInstruction(data){
      this.closeSpecialInstructionModal=true;
      this.deleteSalesChannel=data.channelname;
      this.deleteInstructionId=data.instructionid;
      this.deleteInstructionName=data.instructionname;
    },
   async deleteSpecialInstruction(){
        this.specialInstructionButtonType='delete' 
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '')
        this.isLoading=true;
        this.input={
           clientid:window.localStorage.getItem("selectedClient"),
           type: this.specialInstructionButtonType,
           instrctionname:this.deleteInstructionName,
           channelname:this.deleteSalesChannel,
           id:this.deleteInstructionId,
           useremail:this.createdbyEmail
        }
        await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveSpecialPackingInstruction',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          },
           })
           .then((response) => {
             let deletemsg=response.data.data.msg;
             this.isLoading=false;
             this.$alertify.success(deletemsg);
             this.getSpecialInstruction();
           })
           .catch((httpException) => {
             console.error('exception is:::::::::', httpException)
           });
          this.specialInstructionButtonType='add';
          this.closeSpecialInstructionModal=false;
          this.deleteSalesChannel='';
          this.deleteInstructionId='';
          this.deleteInstructionName='';
    },
    closeStatusSpecialInstructionModal(){
      this.closeSpecialInstructionModal=false;
    },
    async editSpecialInstruction(data){
      this.isEditing=true;
      this.specialInstructionButtonType='edit';
      this.instructionNameEditTextarea=data.instructionname;
      this.editingInstructionId=data.instructionid;
      this.editingSalesChannel=data.channelname;
  },
  extractInput(event){
    if(this.specialInstructionButtonType=="edit"){
      this.instructionNameEditTextarea=event.target.value;
      if(this.instructionNameEditTextarea!=''){
        this.specialInstructionValidation=false;
      }
    }else{
      this.instructionNameAddTextarea=event.target.value;
      if(this.instructionNameAddTextarea!=''){
        this.specialInstructionValidation=false;
      }
    }
  },
  onChangeHandler(event){
    this.extractInput(event)
  },
  onSalesChannelChange(event){
    if(event.target.value){
      this.salesChannelValidation=false;
    }
  },
  async addOrEditSpecialInstruction(){
    var userToken = window.localStorage.getItem('userToken')
    var myStr = userToken.replace(/"/g, '')
    this.isLoading=true;
    if(this.instructionNameEditTextarea.length>500 ||this.instructionNameAddTextarea.length>500 ){
      this.$alertify.error("The Length of the Instruction should be less than 500")
      this.isLoading=false;
      return false;
    }
    
      if(this.specialInstructionButtonType=='edit'){
        if(this.instructionNameEditTextarea==''){
          this.specialInstructionValidation=true;
          this.isLoading=false;
          return false;
        }
        this.input={
          clientid:window.localStorage.getItem("selectedClient"),
          type: this.specialInstructionButtonType,
          instrctionname:this.instructionNameEditTextarea,
          channelname:this.editingSalesChannel,
          id:this.editingInstructionId,
          useremail:this.createdbyEmail
       }
      }else{
        if(this.instructionNameAddTextarea==''){
          this.specialInstructionValidation=true;
          this.isLoading=false;
          return false;
        }
        if(this.searchchannel==''){
          this.salesChannelValidation=true;
          this.isLoading=false;
          return false;
        }
        this.input={
          clientid:window.localStorage.getItem("selectedClient"),
          type: "add",
          instrctionname:this.instructionNameAddTextarea,
          channelname:this.searchchannel,
          useremail:this.createdbyEmail
       }
      }

      await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'saveSpecialPackingInstruction',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr,
        },
         })
         .then((response) => {
           let responsemsg=response.data.data.msg;
           this.isLoading=false;
           if(response.data.data.responsecode===200){
              this.$alertify.success(responsemsg);
           }else{
              this.$alertify.error(responsemsg);
           }
           this.getSpecialInstruction();
         })
         .catch((httpException) => {
           console.error('exception is:::::::::', httpException)
         });
      this.isEditing=false;
      this.specialInstructionButtonType='add';
      this.instructionNameEditTextarea='';
      this.editingSalesChannel='';
      this.instructionNameAddTextarea='';
      this.searchchannel='';
  },

    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumber1: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    saveSpoc(){
      if (this.enablespoc == "") {
        this.enablespocerror = this.$t('config.selectAnOption');
        return false;
      }
      else {
        this.isLoading = true;
        this.enablesubinvcheckerror = "";
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = ({
          config: [{
            "clientid": localStorage.getItem("selectedClient"),
            "type": 'spokenabled',
            "value": this.enablespoc,
            "status": "active",
            "defaultval": 'no'
          }],
          module: 'spokenabled',
          warehouseidlocal: Number(localStorage.getItem("selectedWarehouseid")),
          localclientid: Number(localStorage.getItem("selectedClient"))
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveconfig',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then((response) => {
            if (response.data.data.code == 0) {
              //this.getconfig();
              this.enableautodrcloseerror = "";
              this.isLoading = false;
              this.$alertify.success(response.data.data.msg);
            } else if (response.data.data.code == -1) {
              this.isLoading = false;
              this.$alertify.error(response.data.data.msg)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/config/config.component.js